import { Component, OnInit } from '@angular/core';
import { Step } from '../stepper/step';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StepsService } from '../../services/steps.service';
import { BlockUser, IBlockUserRequest } from '../../classes/block-user';
import { FormGroup } from '@nbg-globals/form-controls';
import { finalize } from 'rxjs/operators';
import { ComponentWithErrors } from '../../classes/component-with-errors';
import { BlockUserHelper } from '../../classes/block-user-helper';
import { UserAuth } from '../../classes/userAuth';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'lock-user-modal',
	template: require('./lock-user-modal.component.html'),
})
export class LockUserModalComponent extends ComponentWithErrors implements OnInit {
	steps: Step[];
	hasCredit = false;
	loading: boolean = false;
	controls: FormGroup<IBlockUserRequest>;
	hasAcceptedTerms: boolean = false;
	public isRebrading = AppSettings.isRebrading;

	get isValid() {
		return this.stepsService && this.stepsService.getCurrentStep === 0
			? this.controls.valid
			: this.hasAcceptedTerms;
	}

	constructor(public activeModal: NgbActiveModal, public stepsService: StepsService) {
		super();
	}

	closeModal(): void {
		this.activeModal.close();
	}

	moveSteps(stepNumber: number): void {
		this.stepsService.setStep(this.steps, stepNumber);
	}

	moveBackStep(): void {
		if (this.stepsService.getCurrentStep === 0) {
			this.closeModal();
		} else {
			this.controls.get('userName').setValue(null);
			this.controls.get('vat').setValue(null);
			this.hasAcceptedTerms = false;
			this.stepsService.moveBackStep(this.steps);
		}
	}

	ngOnInit() {
		this._initStepper();
		this._initData();
	}

	private _initData() {
		this.controls = BlockUserHelper.blockUserControls();
	}

	private _initStepper(): void {
		this.steps = this.stepsService.getTransactionSteps('BlockUser');
		this.stepsService.setStep(this.steps, 0);
	}

	backToTop() {
		document.getElementById('top').scrollIntoView({
			behavior: 'smooth',
		});
	}

	blockUser() {
		BlockUser.BlockUser(this.controls.value)
			.pipe(finalize(() => (this.loading = false)))
			.subscribe(
				(response) => {
					if (response && response.success) {
						this.stepsService.moveNextStep(this.steps);
					} else {
						this.handleError();
					}
				},
				(error) => this.handleError(error)
			);
	}

	emitTerms(hasAcceptedTerms: boolean) {
		this.hasAcceptedTerms = hasAcceptedTerms;
	}

	public moveNext() {
		this.stepsService.getCurrentStep === 0
			? this.stepsService.moveNextStep(this.steps)
			: this.blockUser();
	}
}
